import ClientService from '../services/client-service';
import ShopService from '../services/shop-service';
import DataStore from './data-store';
import { ERROR_CODES, base_url } from './constants';
import _ from 'lodash';
import AddressService from '../services/address-service';
import { Address, Client } from '../../types';
import Vue from 'vue';
import growl from './growl';
import CartService from '../services/cart-service'

let factory = Vue.observable({
	getBrowserInfo,
	updateCardAsync,
	addCardAsync,
	addAddressAsync,
	setErrorMsg,
	setSuccessMsg,
	tokenization: {
		processing: false,
		errorMsg: null,
		successMsg: null,
	},
});

export default factory;

function setSuccessMsg(msg: string) {
	factory.tokenization.successMsg = msg;
}

function setErrorMsg(msg: string) {
	factory.tokenization.errorMsg = msg;
}

function updateCardAsync(card, ClientId, cvc) {
	let payload = {
		card_token: card.token,
		request_id: card.request_id,
		card_expiry_month: card.expirydate.split('/')[0],
		card_expiry_year: card.expirydate.split('/')[1],
		card_holder: card.card_holder,
		cvc: cvc,
	}
	factory.tokenization.processing = true;
	DataStore.post(base_url+'/admin/payment/update-attempt',{
		OrderId: CartService.cart?.OrderId,
		Total: CartService.cart?.Total,
		ShopId: ShopService.shop?.ShopId,
		ClientId,
		cardholder: card.card_holder,
		last4: card.pan.substr(-4),
	},'');
	return getHiPayInstance().updateToken(payload)
		.then(() => {
			DataStore.post(base_url+'/admin/payment/log-success',{},'')
			setSuccessMsg('Code OK')
		})
		.catch((err) => {
			DataStore.post(base_url+'/admin/payment/log-failure',{ error: err },'');
			return Promise.reject({code: JSON.parse(err).code, msg: JSON.parse(err).message})
		})
		.catch(({code, msg}) => {setErrorMsg(msg); growl.error(msg);return Promise.reject({code,msg})})
		.finally(() => factory.tokenization.processing = false)
}

function addCardAsync(newCard, ClientId) {
	let timeoutID = setTimeout(() => {
		factory.tokenization.processing = true;
		DataStore.notifyAngularJs();
	},50);

	let promise;
	try {
		DataStore.post(base_url+'/admin/payment/create-attempt',{
			OrderId: CartService.cart?.OrderId,
			Total: CartService.cart?.Total,
			ShopId: ShopService.shop?.ShopId,
			ClientId,
			cardholder: newCard.cardHolder,
			last4: newCard.cardNumber.substr(-4),
		},'');
		promise = HiPayTokenizeCardAsync(newCard)
		.then((tokenizedCard) => {
			DataStore.post(base_url+'/admin/payment/log-success',{},'');
			if (tokenizedCard.card_category == "PREPAID MEAL") {
				// dont save it, its a ticket resto
				return Promise.reject('Le paiement par ticket restaurant se fait en sélectionnant l\'icone du fournisseur correspondant (Edenred, Paygreen ...)');
			}
			tokenizedCard.multi_use = newCard.multi_use;
			let url = base_url + '/admin/client/new-card-token?ClientId=' + ClientId;
			return DataStore.post(url, tokenizedCard,"Erreur lors de l'enregistrement de la carte")
		})
		.then((data) => _.assign(newCard, data.card))
		.then((newCard) => {
			addCardToLoggedClientAsync(newCard);
			return newCard;
		})
		.catch(err => {
			let msg = err.msg || "Erreur lors de l'enregistrement de la carte";
			factory.tokenization.errorMsg = err.msg;
			growl.error(msg);
			return Promise.reject(err);
		})
		.finally(() => {
			clearTimeout(timeoutID);
			factory.tokenization.processing = false;
			DataStore.notifyAngularJs();
		});
	} catch(err) {
		err.type = ERROR_CODES.TOKENIZATION_ERROR;
		promise = Promise.reject(err);
		clearTimeout(timeoutID);
		factory.tokenization.processing = false;
		DataStore.notifyAngularJs();
	}
	return promise;
}

function addCardToLoggedClientAsync(newCard) {
	ClientService.identity()
	.then((client) => {
		if (!client) {
			return;
		}
		let card = _.find(client.cards,{CCid: newCard.CCid});
		if (card) {
			_.assign(card, newCard);
		} else {
			client.cards.unshift(newCard);
		}
	})
}


/**
* This method can be called for 3 reasons:
* - creating a new address
* - assigning an address to a client
* -		(in the landing-modal, users can choose an address without having logged-in;
	* -		when checking out, they log in and take ownership of that address)
	* - adding Location coordinates to an existing address
	* @param client
	* @param address
	* @returns
	*/
	function addAddressAsync(client: Client = null, addr: Address) {
		return AddressService.getLocationAsync(addr).then(address => {
			let payload = _.omit(address,'latlng','place','$$hashKey');
			payload.ClientId = client && client.ClientId;
			let oldId = addr.AddressId;
			return DataStore.post(base_url + '/admin/address/save', payload,"Impossible d'enregistrer l'adresse")
			.then((data) => {
				if (client) {
					// replace address by the new one
					// if the address has already been used, a new address is created,
					// with a diffrent AddressId
					let index = _.findIndex(client?.addresses,{AddressId: oldId});
					if (index != -1) {
						client.addresses.splice(index,1);
					}
					client.addresses.unshift(data.address);
				}
				return data.address;
			});
		})
	}

	function HiPayTokenizeCardAsync(newCard) {
		var expiryMonth = newCard.expiryDate && newCard.expiryDate.substr(0,2);
		var expiryYear = newCard.expiryDate && newCard.expiryDate.substr(2);
		var params = {
			cardHolder: newCard.cardHolder,
			cardNumber: newCard.cardNumber,
			expiryMonth: expiryMonth,
			expiryYear: expiryYear,
			cvc: newCard.cvc,
			multiUse: newCard.multi_use,
		};
		return getHiPayInstance().tokenize(params)
			.catch((err) => {
				DataStore.post(base_url+'/admin/payment/log-failure',{ error: err },'');
				return Promise.reject({code: err, msg: getHiPayInstance().translations[err], type: ERROR_CODES.TOKENIZATION_ERROR })
			})
	}

	function getHiPayInstance() {
		let test = {
			username: '94658717.stage-secure-gateway.hipay-tpp.com',
			password: 'Test_vLmL3NNj3t01bBcGrnMUvoO9',
			environment: "stage",
			lang: "fr",
		};
		let production = {
			username: '94658716.secure-gateway.hipay-tpp.com',
			password: 'Live_xEAS35QOT9YobK4xvHH4uf2Y',
			environment: "production",
			lang: "fr",
		}
		// if no hipay account, can still tokenize cards and pay on technical account
		// ShopService.shop should never be null
		let environment = ShopService.shop && ShopService.shop.hipay_environment || 'production';

		if (environment == 'sandbox') {
			console.log('HIPAY_TEST on')
			return window.HiPay(test);
		} else {
			console.log('HIPAY_TEST off')
			return window.HiPay(production);
		}
	}

	function getBrowserInfo() {
		return getHiPayInstance().getBrowserInfo();
	}
